import { SectionTitle } from "@/components/common/SectionTitle";
import bookingIcon from "@/assets/icons/booking.svg";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { BookingHistoryList } from "@/features/booking-history/BookingHistoryList";
import { useState } from "react";
import { useBookingHistory } from "@/features/booking-history/hook/useBookingHistory";

export default function BookingHistoryPage() {
  const [searchKeyword, setSearchKeyword] = useState("");

  const { loading, bookingHistory, fetchBookingHistory } = useBookingHistory();

  const handleSearch = () => {
    fetchBookingHistory(searchKeyword, 1);
  };

  return (
    <div className="mx-auto max-w-7xl px-4 pt-4 pb-16 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <SectionTitle img={bookingIcon} title="Booking History" />
      </div>

      <div className="mt-6 flex flex-col gap-6 md:flex-row md:items-center">
        <div className="relative md:flex-4/5">
          <Search
            size={18}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C2C2C2]"
            aria-hidden="true"
          />

          <Input
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            className="h-14 rounded-2xl border-border bg-card pl-12 pr-4 text-sm font-medium uppercase text-muted-foreground placeholder:text-border"
            placeholder="Booking no. / Name / Contact no."
          />

          {searchKeyword && (
            <button
              type="button"
              onClick={() => {
                setSearchKeyword("");
                fetchBookingHistory("", 1);
              }}
              className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-[#C2C2C2] hover:text-foreground"
              aria-label="Clear search"
            >
              <X size={18} />
            </button>
          )}
        </div>

        <Button
          type="button"
          variant="default"
          onClick={handleSearch}
          className="w-full cursor-pointer md:flex-1/5"
        >
          Search
        </Button>
      </div>

      <Separator className="mt-8 text-border" />

      <h2 className="mt-8 text-sm font-semibold text-secondary-foreground">
        Last Bookings
      </h2>

      <BookingHistoryList
        loading={loading}
        bookingHistory={bookingHistory}
        onPageChange={(page) => {
          fetchBookingHistory(searchKeyword, page);
        }}
      />
    </div>
  );
}
